import React from "react";

export default function NoMatch() {
	return (
		<div>
			<h2>Nothing to see here!</h2>
		</div>
	);
}
